import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IPaginatedResponse } from "@Common/api/types/pagination";
import { DEFAULT_CURSOR } from "@Common/hooks/Pagination/helpers.tsx";
import { ITradeInPayOff } from "@DataPages/types/financeManagement/model/trade-in-payoff.ts";
import { apiInstance, gql } from "@/services/httpAdapter.ts";
import { errorLogger } from "@Common/helpers/logger.ts";

const NotFoundResponse: IPaginatedResponse<ITradeInPayOff> = {
	edges: [],
	pageInfo: { endCursor: "", hasNextPage: false },
};

export async function getTradeInPayOffs(
	locationId: string,
	commissionCycleId: string,
	payPeriodId: string,
	after = DEFAULT_CURSOR.after,
	first = DEFAULT_CURSOR.first
) {
	const query = gql`
		query getTradeInPayoffs($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $pagination: PaginationInput) {
			getTradeInPayOffs(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				edges {
					cursor
					node {
						_id
						locationId
						commissionCycleId
						payPeriodId
						financeEmployeeName
						financeEmployeeId
						dealNumber
						dealVin
						dealStockId
						dealStatus
						tradeInVin
						actualCashValue
						stockID
						tradeInAmt
						overallowanceAmt
						payoff
						creationDateTime
						saleDate
						createdAt
						updatedAt
						lender {
							lenderName
							lenderType
							address {
								addr1
								city
								state
								zip
							}
						}
						vehicle {
							vehicleYr
							modelDesc
							carline
							vin
							extClrDesc
							makePfx
							vehicleMake
							accentClr
							vehicleDetail {
								licExpDate
								noOfCyl
								odomReading
								newUsed
								weight
								licNo
								unitsOfMeasure
							}
						}
					}
				}
				pageInfo {
					endCursor
					hasNextPage
					totalCount
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination: {
			first,
			after,
		},
	};

	try {
		const queryResponse: GraphqlQueryResponse<"getTradeInPayOffs", IPaginatedResponse<ITradeInPayOff>> = await apiInstance.post(
			"/graphql",
			{
				query,
				variables,
			}
		);
		return queryResponse.data.data?.getTradeInPayOffs ?? NotFoundResponse;
	} catch (err) {
		errorLogger(err as Error, { function: "getTradeInPayOffs", message: "Failed to get trade in payoffs", variables });
		return null;
	}
}
